// Mineurs (D-036, D-103) : la règle de la base (_ref_minor) côté app. Une fiche est mineure si elle se
// connecte avec un code perso, ou si elle a moins de 18 ans. Ses écrans lui parlent comme à un enfant :
// pas d'exemple d'adulte (« travail »), pas de ligne technique, pas de consigne de gestion.

export interface MinorLike { birth_date?: string | null; login_handle?: string | null }

/** Moins de 18 ans à cette date (date de naissance « AAAA-MM-JJ »). */
export function underAge(birth: string, today = new Date()): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birth);
  if (!m) return false;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const age = today.getFullYear() - y - (today.getMonth() + 1 < mo || (today.getMonth() + 1 === mo && today.getDate() < d) ? 1 : 0);
  return age < 18;
}

/** Une fiche de mineur : un code perso, ou moins de 18 ans. */
export function isMinorPerson(p: MinorLike | null | undefined, today = new Date()): boolean {
  if (!p) return false;
  if (p.login_handle) return true;
  return !!p.birth_date && underAge(p.birth_date, today);
}

/** L'exemple du motif d'absence : celui d'un enfant pour un mineur (jamais « travail »). */
export const absenceExample = (minor: boolean): string =>
  (minor ? 'ex. dentiste, blessure, sortie scolaire' : 'ex. travail, blessure, examen');

/** « Ta marraine », « Ton parrain » : la marraine vue par sa filleule. */
export const myMentorWord = (word: 'marraine' | 'parrain'): string => (word === 'parrain' ? 'Ton parrain' : 'Ta marraine');
